import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { PublicAssetProductState } from '../types';

const setInitialCurrentProductReducer = (
  state: PublicAssetProductState,
  action: PayloadAction<AppBundle.Api.Entity.App.V1.IAbstractProduct>,
) => {
  const abstractProduct = action.payload;
  state.currentProduct = abstractProduct.products?.find(
    (product) => product.productId === abstractProduct.initialProduct.productId,
  );
  state.selectedAbstractProduct = abstractProduct;
};

export default setInitialCurrentProductReducer;
